import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { Form, Row, Col, Button, Image } from 'react-bootstrap';
import API_ENDPOINTS from '../../config/apiConfig';
import { useData } from '../../context/DataContext';
import { fetchFromApi } from '../../config/api';

function EditArtistModel(props) {
    const { fetchArtistData } = useData();

    const [artistData, setArtistData] = useState(props.editData || {});
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setArtistData({
            ...artistData,
            [name]: value,
        });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setArtistData({
                    ...artistData,
                    image: reader.result,
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleRemoveImage = () => {
        setArtistData({
            ...artistData,
            image: "", // Clear the image field
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (artistData.mobile && artistData.mobile.length !== 10) {
            setError("Please enter a valid 10-digit mobile number.");
            return;
        }

        setLoading(true);

        try {
            const formBody = {
                id: artistData.id,
                name: artistData.name,
                email: artistData.email,
                address: artistData.address,
                mobile: artistData.mobile,
                about: artistData.about,
                image: artistData.image,
            };

            const data = await fetchFromApi(API_ENDPOINTS.UPDATE_ARTIST, 'POST', formBody);

            if (data.status === "success") {
                setSuccessMsg("Artist Data Updated Successfully");

                setTimeout(async () => {
                    setSuccessMsg("");
                    props.onHide();
                    await fetchArtistData();
                }, 2000);
            } else {
                setError("Failed to update artist. Please check the details and try again.");
            }
        } catch (error) {
            setError("An error occurred. Please try again.");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...props} size="lg" aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">Edit Artist</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Group controlId="formArtistName">
                                <Form.Label>Artist Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={artistData.name || ''}
                                    onChange={handleInputChange}
                                    required
                                    isInvalid={error && !artistData.name}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter the artist's name.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                            <Form.Group controlId="formArtistEmail">
                                <Form.Label>Artist Email <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={artistData.email || ''}
                                    onChange={handleInputChange}
                                    required
                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                    isInvalid={error && (!artistData.email || !artistData.email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/))}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a valid email address.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Group controlId="formArtistMobile">
                                <Form.Label>Artist Mobile</Form.Label>
                                <Form.Control
                                    type="tel"
                                    name="mobile"
                                    value={artistData.mobile || ''}
                                    onChange={handleInputChange}
                                    pattern="\d{10}"
                                    maxLength={10}
                                    required
                                    onKeyPress={(e) => {
                                        if (!/^\d$/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    isInvalid={error && artistData.mobile && artistData.mobile.length !== 10}
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please enter a valid 10-digit mobile number.
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>

                        <Col xs={12} md={6}>
                            <Form.Group controlId="formArtistAddress">
                                <Form.Label>Artist Address</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="address"
                                    value={artistData.address || ''}
                                    onChange={handleInputChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row className="mb-3">
                        <Col xs={12} md={6}>
                            <Form.Group controlId="formArtistAbout">
                                <Form.Label>About Artist</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    name="about"
                                    value={artistData.about || ''}
                                    onChange={handleInputChange}
                                    rows={8}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={6}>
                            <Form.Group controlId="formArtistImage">
                                <Form.Label>Artist Image <span className="text-danger">Recommended 230 px X 280 px</span></Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageChange}
                                />
                                {artistData.image && (
                                    <>
                                        <div style={{ position: 'relative', display: 'inline-block' }}>
                                            <Image
                                                src={artistData.image}
                                                fluid
                                                className="mt-3"
                                                style={{ width: '150px', height: '150px' }}
                                            />
                                                 <Button
                                                    variant="danger"
                                                    size="sm"
                                                    style={{
                                                        position: 'absolute',
                                                        top: '5px',
                                                        right: '-10px',
                                                        borderRadius: '50%',
                                                    }}
                                                    onClick={handleRemoveImage}
                                                >
                                                    &times;
                                                </Button>
                                        </div>
                                    </>
                                )}
                                {error && (
                                    <Form.Control.Feedback type="invalid">
                                        {error}
                                    </Form.Control.Feedback>
                                )}
                            </Form.Group>
                        </Col>
                    </Row>

                    {successMsg && <div className="text-success">{successMsg}</div>}
                </Form>
            </Modal.Body>
            <Modal.Footer>
    
                <Button
                    type="button"
                    variant="outline-success"
                    className="f-14"
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? "Updating ..." : "Update"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EditArtistModel;
